module.exports = __webpack_public_path__ + "img/Station Planning_02.136005a8.jpg";